export default {
  "content": "<path fill=\"#333\" fill-rule=\"evenodd\" d=\"M16.5 19.436c0 1.53-.755 2.23-2.3 2.23H2.8c-1.546 0-2.3-.7-2.3-2.23V11.41c0-1.29.73-1.99 1.904-2.154v-2.81C2.404 2.323 5.362.333 8.5.333s6.096 1.99 6.096 6.113V9.2c1.281.12 1.904.831 1.904 2.209v8.026zM4.33 6.216v2.985l8.336-.01V6.215c0-2.744-1.928-4.199-4.167-4.199-2.24 0-4.168 1.455-4.168 4.2z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "17",
    "height": "22",
    "fill": "none",
    "viewBox": "0 0 17 22"
  }
};